import { render, staticRenderFns } from "./IndicationBox.vue?vue&type=template&id=4b220c74&scoped=true&lang=pug"
import script from "./IndicationBox.vue?vue&type=script&lang=js"
export * from "./IndicationBox.vue?vue&type=script&lang=js"
import style0 from "./IndicationBox.vue?vue&type=style&index=0&id=4b220c74&prod&lang=scss"
import style1 from "./IndicationBox.vue?vue&type=style&index=1&id=4b220c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b220c74",
  null
  
)

export default component.exports